import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取理赔列表
export const getClaimList = (params) => {
  return axios.request({
    url: "/finance/claim",
    method: "get",
    params,
  });
};

// 审核
export const auditClaim = (data) => {
  return axios.request({
    url: `/finance/claim/verify/${data.id}`,
    method: "post",
    data,
  });
};

// 审核记录
export const getAuditRecord = (id) => {
  return axios.request({
    url: `/finance/claim/log/${id}`,
    method: "get",
  });
};

// 获取理赔配置
export const getClaimConfig = () => {
  return axios.request({
    url: "/common/claim",
    method: "get",
  });
};

// 理赔打印
export const printClaim = (id) => {
  return axios.request({
    url: `/finance/claim/pdf/${id}`,
    method: "get",
  });
};

// 具体责任方
export const getClaimDuty = (params) => {
  return axios.request({
    url: `/common/duty/${params.id}`,
    method: "get",
    params,
  });
};

// 获取状态导航栏
export const getStatusNav = () => {
  return axios.request({
    url: "/finance/claim/navbar",
    method: "get",
  });
};

// 获取绑定人员
export const getBindUser = (id) => {
  return axios.request({
    url: `/finance/claim/user/${id}`,
    method: "get",
  });
};

// 绑定审核人员
export const bindAuditUser = (data) => {
  return axios.request({
    url: `/finance/claim/bind/${data.id}`,
    method: "post",
    data,
  });
};

export const upload = (data) => {
  return axios.request({
    url: `/common/upload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data,
  });
};

// 上传举证文件
export const uploadFile = (data) => {
  return axios.request({
    url: `/finance/claim/upload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data,
  });
};

// 删除举证文件
export const deleteFile = (data) => {
  return axios.request({
    url: `/finance/claim/deleteFile/${data.id}`,
    method: "post",
    data,
  });
};

// 获取理赔列表
export const getClaimDetail = (id) => {
  return axios.request({
    url: "/finance/claim/" + id,
    method: "get",
  });
};

// 新增理赔单
export const addClaim = (data) => {
  return axios.request({
    url: "/finance/claim",
    method: "post",
    data,
  });
};

// 编辑理赔单
export const editClaim = (data) => {
  return axios.request({
    url: "/finance/claim/" + data.id,
    method: "put",
    data,
  });
};

// 取消理赔单
export const cancelClaim = (data) => {
  return axios.request({
    url: "/finance/claim/cancel/" + data.id,
    method: "post",
  });
};

// 删除理赔单
export const deleteClaim = (data) => {
  return axios.request({
    url: "/portal/claim/" + data.id,
    method: "DELETE",
    data,
  });
};

// 理赔导出
export const exportClaim = (params) => {
  return axios.request({
    url: "/finance/claim/export",
    method: "get",
    params,
  });
};

// 生成账单
export const createBill = (params) => {
  return axios.request({
    url: "/finance/claim/createBill",
    method: "get",
    params,
  });
};

// 批量设置追赔
export const setClaim = (data) => {
  return axios.request({
    url: " /finance/claim/traceker",
    method: "post",
    data,
  });
};

// 保存举证文件
export const saveExtend = (data) => {
  return axios.request({
    url: " /finance/claim/saveExtend/" + data.id,
    method: "post",
    data,
  });
};

// 根据方案获取理赔金额
export const getAmount = (data) => {
  return axios.request({
    url: " /finance/claim/getAmount/" + data.id,
    method: "post",
    data,
  });
};

// 批量审批
export const batchAudit = (data) => {
  return axios.request({
    url: " /finance/claim/batchVerify",
    method: "post",
    data,
  });
};

export const claimFreight = (params) => {
  return axios.request({
    url: "/finance/claim/claimFreight",
    method: "get",
    params,
  });
};

export const ordertype = (data) => {
  return axios.request({
    url: "/finance/claim/ordertype",
    method: "post",
    data,
  });
};


export const saveClaimFreight = (data) => {
  return axios.request({
    url: "/finance/claim/saveClaimFreight",
    method: "post",
    data,
  });
};

export const checkSale = (params) => {
  return axios.request({
    url: "/finance/claim/checkSale",
    method: "get",
    params,
  });
};

export const cancelRefuse = (id) => {
  return axios.request({
    url: "/finance/claim/cancelRefuse/" + id,
    method: "post",
  });
};

export const uploadFreight = data => {
  return axios.request({
    url: `/finance/claim/uploadFreight`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data
  });
};

export const getReplenish = (id) => {
  return axios.request({
    url: "/finance/claim/getReplenish/" + id,
    method: "GET",
  });
};
export const addReplenish = (data) => {
  return axios.request({
    url: "/finance/claim/addReplenish/" + data.id,
    method: "POST",
    data
  });
};

export const delReplenish = (id) => {
  return axios.request({
    url: "/finance/claim/delReplenish/" + id,
    method: "POST",
  });
};

export const specialApply = (data) => {
  return axios.request({
    url: "/finance/claim/specialApply",
    method: "POST",
    data
  });
};

export const uploadFinance = data => {
  return axios.request({
    url: `/finance/claim/uploadFinance`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data
  });
};
